import httpClient from "./httpClient";

const base = "/exam-routine-generate";

export function saveExamRoutineGenerate(payload) {
  return httpClient.post(base, payload).then((res) => res.data);
}

export function listExamRoutineGenerate(academicYear, examId, classId, groupIds) {
  const query = new URLSearchParams();
  query.append("academicYear", academicYear);
  query.append("examId", examId);
  query.append("classId", classId);
  (groupIds || []).forEach((id) => query.append("groupIds", id));
  return httpClient.get(`${base}?${query.toString()}`).then((res) => res.data.data);
}

export function deleteExamRoutineGenerate(examRoutineId) {
  return httpClient.delete(`${base}/${examRoutineId}`).then((res) => res.data);
}
